// // src/pages/break/BreakTimeLogPage.jsx
// import React, { useEffect, useState, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchBreakLogs, exportBreakLogs, clearError } from 'src/store/slices/breakTimeLogSlice';
// import { Loader2 } from 'lucide-react';
// import DataTable from '../../components/common/DataTable';
// import PageHeader from '../../components/common/PageHeader';
// import { Badge } from '../../components/ui/badge';
// import { toast } from 'sonner';
// import { usePermissions } from 'src/hooks/usePermissions';

// const AttendancePage = () => {
//   const dispatch = useDispatch();

//   const {
//     logs = [],
//     pagination = { count: 0, page_size: 10 },
//     isLoading,
//     error,
//   } = useSelector((state) => state.breakTimeLog || {});

//   const { canRead, canExport = false } = usePermissions('break_time_log');

//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchTerm, setSearchTerm] = useState('');

//   const refetch = useCallback(() => {
//     dispatch(fetchBreakLogs({ page, pageSize, search: searchTerm, title: 'attendance' }));
//   }, [dispatch, page, pageSize, searchTerm]);

//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   useEffect(() => {
//     if (error) {
//       toast.error(typeof error === 'string' ? error : 'Something went wrong');
//       dispatch(clearError());
//     }
//   }, [error, dispatch]);

//   const handleExport = () => {
//     if (!canExport) {
//       toast.error("You don't have permission to export");
//       return;
//     }
//     dispatch(exportBreakLogs());
//     toast.success('Export started...');
//   };

//   // 🔹 Active attendance (ongoing)
//   const activeAttendance = logs.find((log) => !log.punch_out);

//   // 🔹 Table columns (ATTENDANCE ONLY)
//   const columns = [
//     {
//       accessorKey: 'employee_name',
//       header: 'Employee Name',
//       cell: ({ row }) => (
//         <span className="font-medium">
//           {row.original.employee_name || '-'}
//         </span>
//       ),
//     },
//     {
//       accessorKey: 'company_name',
//       header: 'Company Name',
//       cell: ({ row }) => row.original.company_name || '-',
//     },
//     {
//       accessorKey: 'punch_in',
//       header: 'Punch In',
//       cell: ({ row }) =>
//         row.original.punch_in ? (
//           new Date(row.original.punch_in).toLocaleTimeString([], {
//             hour: '2-digit',
//             minute: '2-digit',
//           })
//         ) : (
//           '-'
//         ),
//     },
//     {
//       accessorKey: 'punch_out',
//       header: 'Punch Out',
//       cell: ({ row }) =>
//         row.original.punch_out ? (
//           new Date(row.original.punch_out).toLocaleTimeString([], {
//             hour: '2-digit',
//             minute: '2-digit',
//           })
//         ) : (
//           <Badge variant="secondary">Ongoing</Badge>
//         ),
//     },
//     {
//       id: 'status',
//       header: 'Status',
//       cell: ({ row }) => {
//         const isActive = !row.original.punch_out;
//         return (
//           <Badge variant={isActive ? 'destructive' : 'secondary'}>
//             {isActive ? 'Active' : 'Completed'}
//           </Badge>
//         );
//       },
//     },
//   ];

//   return (
//     <div className="space-y-6 animate-fade-in">
//       <PageHeader
//         title="Attendance Logs"
//         description="View employee punch-in and punch-out records"
//       />

//       {/* ACTIVE ATTENDANCE BANNER */}
//       {activeAttendance && (
//         <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded-lg">
//           🟡 Attendance Active — Started at{' '}
//           <strong>
//             {new Date(activeAttendance.punch_in).toLocaleTimeString([], {
//               hour: '2-digit',
//               minute: '2-digit',
//             })}
//           </strong>
//         </div>
//       )}

//       {isLoading && logs.length === 0 ? (
//         <div className="flex justify-center py-12">
//           <Loader2 className="h-6 w-6 animate-spin mr-2" />
//           <span>Loading attendance logs...</span>
//         </div>
//       ) : canRead ? (
//         <DataTable
//           data={logs}
//           columns={columns}
//           searchPlaceholder="Search employee..."
//           pageIndex={page - 1}
//           pageSize={pageSize}
//           pageCount={Math.ceil(pagination.count / pagination.page_size)}
//           onPageChange={(i) => setPage(i + 1)}
//           onPageSizeChange={setPageSize}
//           onSearch={setSearchTerm}
//           isLoading={isLoading}
//           showExport={canExport}
//           onExport={handleExport}
//           showImport={false}
//         />
//       ) : (
//         <p className="text-center py-12 text-muted-foreground">
//           You don’t have permission to view attendance logs
//         </p>
//       )}
//     </div>
//   );
// };

// export default AttendancePage;


// src/pages/break/BreakTimeLogPage.jsx
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBreakLogs, exportBreakLogs, clearError } from 'store/slices/breakTimeLogSlice';
import { Loader2 } from 'lucide-react';
import DataTable from '../../components/common/DataTable';
import PageHeader from '../../components/common/PageHeader';
import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';
import { usePermissions } from 'hooks/usePermissions';
import { formatDateTime } from 'utlis/formateDateTime';
import LogDateFilter from 'components/common/LogDateFilter';

const AttendancePage = () => {
  const dispatch = useDispatch();

  // 🔹 Get current logged-in user
  const currentUser = useSelector((state) => state.auth.user);
  const currentUserId = currentUser?.id;

  const {
    logs: allLogs = [],
    pagination = { count: 0, page_size: 10 },
    isLoading,
    error,
  } = useSelector((state) => state.breakTimeLog || {});

  const { canRead, canExport = false } = usePermissions('break_time_log');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilters, setDateFilters] = useState({});

  // 🔹 Filter logs to current user only for active session detection
  const userLogs = useMemo(() => {
    if (!currentUserId) return [];
    return allLogs.filter(log => log.employee === currentUserId);
  }, [allLogs, currentUserId]);

  // 🔹 Active attendance — ONLY for current user
  const activeAttendance = useMemo(() => {
    return userLogs.find(log => !log.punch_out);
  }, [userLogs]);

  const refetch = useCallback(() => {
    // Always fetch all logs for the table (admin view), but title=attendance
    dispatch(fetchBreakLogs({
      page,
      pageSize,
      search: searchTerm,
      title: 'attendance',
      ...dateFilters,
    }));
  }, [dispatch, page, pageSize, searchTerm, dateFilters]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (error) {
      toast.error(typeof error === 'string' ? error : 'Something went wrong');
      dispatch(clearError());
    }
  }, [error, dispatch]);

  const handleExport = () => {
    if (!canExport) {
      toast.error("You don't have permission to export");
      return;
    }
    dispatch(exportBreakLogs({ title: 'attendance', ...dateFilters }));
    toast.success('Export started...');
  };

  const calculateDuration = (punchIn, punchOut) => {
    if (!punchIn) return '-';

    const start = new Date(punchIn);
    const end = punchOut ? new Date(punchOut) : new Date(); // live if no punch_out

    const diffMs = end - start;
    if (diffMs < 0) return '-';

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || hours > 0) parts.push(`${minutes}m`); // show minutes if hours exist
    if (seconds > 0 || (minutes === 0 && hours === 0)) parts.push(`${seconds}s`);

    return parts.join(' ') || '0s';
  };

  // 🔹 Table columns (same for all users if permitted)
  const columns = [
    {
      accessorKey: 'employee_name',
      header: 'Employee Name',
      cell: ({ row }) => (
        <span className="font-medium">
          {row.original.employee_name || '-'}
        </span>
      ),
    },
    {
      accessorKey: 'company_name',
      header: 'Company',
      cell: ({ row }) => row.original.company_name || '-',
    },
    {
      accessorKey: 'punch_in',
      header: 'Clock In',
      cell: ({ row }) =>
        row.original.punch_in ? (
          formatDateTime(row.original.punch_in) ?? '-'
        ) : (
          '-'
        ),
    },
    {
      accessorKey: 'punch_out',
      header: 'Clock Out',
      cell: ({ row }) =>
        row.original.punch_out ? (
          formatDateTime(row.original.punch_out) ?? '-'
        ) : (
          <Badge variant="secondary">Ongoing</Badge>
        ),
    },
    {
      id: 'duration',
      header: 'Duration',
      cell: ({ row }) => {
        const { punch_in, punch_out } = row.original;
        return (
          <span className="text-sm text-green-500">
            {calculateDuration(punch_in, punch_out)}
          </span>
        );
      },
    },
    {
      id: 'status',
      header: 'Status',
      cell: ({ row }) => {
        const isActive = !row.original.punch_out;
        return (
          <Badge variant={isActive ? 'destructive' : 'secondary'}>
            {isActive ? 'Active' : 'Completed'}
          </Badge>
        );
      },
    },
    // {
    //   accessorKey: 'created_at',
    //   header: 'Date',
    //   cell: ({ row }) =>
    //     new Date(row.original.created_at).toLocaleDateString('en-IN', {
    //       day: '2-digit',
    //       month: 'short',
    //       year: 'numeric',
    //     }),
    // },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      <PageHeader
        title="Attendance Logs"
        description="View and manage employee clock-in/out records"
      />

      <div className='mb-5'>
        <LogDateFilter onFilter={(f) => setDateFilters(f)} />
      </div>

      {/* 🔹 PERSONAL ACTIVE ATTENDANCE BANNER — Only for current user */}
      {activeAttendance && (
        <div className="bg-amber-50 dark:bg-amber-950/30 border border-amber-300 dark:border-amber-800 rounded-xl p-5 shadow-sm">
          <div className="flex items-center gap-3">
            <div className="w-4 h-4 rounded-full bg-amber-500 animate-pulse" />
            <div>
              <p className="font-semibold text-amber-900 dark:text-amber-100">
                You are currently clocked in
              </p>
              <p className="text-sm text-amber-700 dark:text-amber-300 mt-1">
                Started at:{' '}
                <strong>
                  {new Date(activeAttendance.punch_in).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </strong>
              </p>
            </div>
          </div>
        </div>
      )}

      {/* {isLoading && allLogs.length === 0 ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin mr-3" />
          <span className="text-lg">Loading attendance logs...</span>
        </div>
      ) : !canRead ? (
        <div className="text-center py-20">
          <p className="text-lg text-muted-foreground">
            You don’t have permission to view attendance logs
          </p>
        </div>
      ) : ( */}
      <DataTable
        data={allLogs} // Admins see all, regular users see filtered via backend if needed
        columns={columns}
        totalCount={pagination.count}
        searchPlaceholder="Search by employee name..."
        pageIndex={page - 1}
        pageSize={pageSize}
        pageCount={Math.ceil(pagination.count / pagination.page_size)}
        onPageChange={(i) => setPage(i + 1)}
        onPageSizeChange={setPageSize}
        onSearch={setSearchTerm}
        isLoading={isLoading}
        showExport={canExport}
        onExport={handleExport}
        showImport={false}
      />
      {/* )} */}
    </div>
  );
};

export default AttendancePage;